import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
// import { title } from '@core/utils/filter'
import Filter from '@/views/modules/Utils/filters'

import { useUtils } from '@core/libs/i18n'
import { ExportDataServices } from '@/share/reports/exportService'


export default function useDevicesList() {

  const { t } = useUtils()
  const refDeviceListTable = ref(null)

  const tableColumns = [
    { key: 'name', sortable: true, label: t('Name') },
    { key: 'plate_number', sortable: true, label: t('Plate Number') },
    { key: 'plate_chars', sortable: true, label: t('Plate Chars') },
    { key: 'owner', sortable: true, label: t('Owner') },
    { key: 'contract', sortable: true, label: t('Contract')},
    { key: 'uniqueid', sortable: true, label: t('Unique Id') },
    { key: 'lastupdate', sortable: true, label: t('Last Update') },
    { key: 'rfid_lastupdate', sortable: true, label: t('RFID Update') },
    { key: 'category', sortable: true, label: t('Category') },
    { key: 'actions', label: t('actions') },
  ]

  const perPage = ref(10)
  const totalDevices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('created_at')
  const isSortDirDesc = ref(true)

  const { ownersOptions, categoriesOptions, contractsOptions,contractsOptions_orig, groupsOptions, typesOptions } = Filter('device')

  //  filters
  const categoriesFilter = ref([])
  const ownersFilter = ref([])
  const typeFilter = ref(null)
  const groupFilter = ref(null)
  const contractsFilter = ref([])
  const isSupportFilter=ref(null)

  const requestStatus = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refDeviceListTable.value ? refDeviceListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalDevices.value,
    }
  })

  // const auth = store.getters['auth/user']
  //
  // if (auth.role === 'admin') {
  //   store.dispatch('app-device/getOwners').then(res =>
  //     ownersOptions.value = [{id: auth.id, name: auth.name },...res.data]).catch(res => console.log(res))}
  // else if (auth.role === 'manager') ownersOptions.value = [{id: auth.id, name: auth.name }]

  const refetchData = () => {
    refDeviceListTable.value.refresh()
  }

  const filter = ref({})

    ///watch woner option refliter contracts
    const refliterContractByWoners=(owners)=>{          
      let result=contractsOptions_orig.value.filter((i)=>owners.includes(i.contractor_id))         
      contractsOptions.value=result;
       if(owners.length==0){     contractsOptions.value=contractsOptions_orig.value; }         
    }      
watch([ownersFilter], () => {refliterContractByWoners(ownersFilter.value)})
/////end


  watch([currentPage, perPage, searchQuery, categoriesFilter, ownersFilter,
    typeFilter, groupFilter, contractsFilter,isSupportFilter], () => {
      filter.value = {
        ...(ownersFilter.value && { owners: ownersFilter.value }),
        ...(typeFilter.value && { types: typeFilter.value }),
        ...(groupFilter.value && { group: groupFilter.value }),
        ...(categoriesFilter.value && { categories: categoriesFilter.value }),
        ...(contractsFilter.value && { contracts: contractsFilter.value }),
        ...(isSupportFilter.value && {isSupport:isSupportFilter.value}) ,
        ...(searchQuery.value && { q: searchQuery.value })
      }
      if(isSupportFilter.value=="all"){delete filter.value.isSupport}

      refetchData()
    })

  const fetchDevices = (ctx, callback) => {
    requestStatus.value = true
    store
      .dispatch('app-device/fetchDevices', {
        q: searchQuery.value,
        length: perPage.value,
        page: currentPage.value,
        sortBy:isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc',
        ...filter.value

      })
      .then(response => {
        requestStatus.value = false
        const { data } = response.data.data
        const { total } = response.data.data.meta

        callback(data)
        totalDevices.value = total
      })
      .catch(() => {
        requestStatus.value = false
      })
  }


  const Export = (fileType) => {
   
   
    requestStatus.value = true
    let req = filter.value;
    Object.assign(req, { exporter: fileType, export: "devicesList",exportType:fileType })
    ExportDataServices.exportReport(req).
      then(
        (res) => {
          requestStatus.value = false
        }
      ).catch(reason => {
        console.log('Export faild')
        requestStatus.value = false
      })


  }

  return {
    Export,
    fetchDevices,
    tableColumns,
    perPage,
    currentPage,
    totalDevices,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDeviceListTable,

    ownersOptions,
    categoriesOptions,
    contractsOptions,
    typesOptions,
    groupsOptions,

    categoriesFilter,
    ownersFilter,
    typeFilter,
    groupFilter,
    contractsFilter,
    isSupportFilter,

    requestStatus,

    refetchData,

  }
}
